module.exports = __webpack_public_path__ + "static/media/Health-global.405a2f44.svg";